<template>
  <div>
    <UContainer>
      <UCard
        v-if="directions?.length"
        class="mb-20"
        title="Направления спорта"
        :ui="{
          title: 'typo-heading-h5',
        }"
      >
        <div class="mb-8">
          <ExpandableList
            v-slot="{ displayItems }"
            :limit="6"
            :items="directions"
          >
            <div
              class="grid grid-cols-3 max-xl:grid-cols-2 max-md:grid-cols-1 gap-5 mb-5 max-xl:gap-4"
            >
              <SmallCard
                v-for="(direction, index) in displayItems"
                :key="index"
                class="max-xl:h-auto"
                :top="direction.name"
                :slug="direction.slug"
                bottom-top
                direction-size="small"
                :to="'/directions/' + direction.id"
                :ui="{
                  root: 'bg-background-bg1!',
                  body: 'max-xl:p-5! max-md:p-3! max-md:pr-1.5! gap-5',
                  top: 'typo-heading-h5! mb-2.5!',
                  link: 'hidden',
                }"
              >
                <template #bottom>
                  <div class="flex gap-1 flex-wrap">
                    <UBadge
                      v-for="lesson in lessonTypes"
                      :key="lesson.id"
                      :label="lesson.name"
                    />
                  </div>
                </template>
              </SmallCard>
            </div>
          </ExpandableList>
        </div>

        <h5 class="text-size-h5 font-bold font-lato! mb-4">Документы (мок)</h5>

        <ExpandableList
          v-slot="{ displayItems }"
          :limit="3"
          :items="[1, 2, 3, 4, 5]"
        >
          <div
            class="grid grid-cols-3 max-xl:grid-cols-2 max-md:grid-cols-1 gap-5"
          >
            <SmallCard
              v-for="(item, index) in displayItems"
              :key="index"
              class="max-xl:h-auto"
              icon="i-local-file-award"
              top="Моковая Лицензия"
              no-link
              :ui="{
                root: 'bg-background-bg1',
                top: 'typo-paragraph-sm-regular mb-0.5!',
                bottom: 'typo-paragraph-md-regular',
                iconWrapper: 'w-8 h-8 bg-info text-white',
              }"
            >
              <template #bottom>
                <a class="text-accent-default font-medium" href="#">
                  Мок ЛИЦ-2024-001
                </a>
              </template>
            </SmallCard>
          </div>
        </ExpandableList>
      </UCard>

      <AboutSchoolSection
        class="mb-20 max-xl:mb-15 max-md:mb-12"
        :images="[
          'https://picsum.photos/430/400',
          'https://picsum.photos/630/400',
          'https://picsum.photos/630/400',
          'https://picsum.photos/630/400',
        ]"
        :description="MOCK_DESCRIPTION"
      />

      <QuoteBlock
        quote="«Моковый спорт — это не только физическая активность, но и важный аспект формирования характера и командного духа. Мы стремимся развивать в наших учениках не только спортивные навыки, но и жизненные ценности»."
        author-name="Алексей Моков"
        author-role="Моковый директор"
        author-image="https://picsum.photos/60/60"
      />
    </UContainer>

    <BestTrainersSection
      v-if="trainers?.length"
      class="bg-transparent!"
      :trainers="trainers"
      title="Лучшие тренеры"
      :loading="pending"
      :ui="{
        card: 'bg-transparent!',
        cardBody: 'px-0!',
      }"
    />

    <OurPrideSection
      v-if="MOCK_STUDENTS.length"
      title="Наша гордость"
      :students="MOCK_STUDENTS"
      :loading="pending"
    />

    <NewsAndEventsSection
      v-if="news?.length"
      :news="news"
      :loading="pending"
      title="Общие новости и события"
    />

    <div v-if="gallery.length" class="overflow-x-hidden">
      <SPGallerySection
        :images="gallery"
        :per-view="galleryImagesAmount"
        class="bg-white py-15 max-lg:py-10 rounded-[30px] max-md:-mx-2.5"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BestTrainersSection from '~/components/main-page/BestTrainersSection.vue'
import AboutSchoolSection from '../components/AboutSchoolSection.vue'
import QuoteBlock from '~/components/QuoteBlock.vue'
import NewsAndEventsSection from '~/components/main-page/NewsAndEventsSection.vue'
import OurPrideSection from '~/components/main-page/OurPrideSection.vue'
import { MOCK_DESCRIPTION, MOCK_STUDENTS } from '~/shared/school.js'

defineOptions({
  name: 'SchoolDetailAbout',
})

const route = useRoute()

const breakpoints = useBreakpointsStore()
const { isLessThan } = breakpoints
const { isMobile } = storeToRefs(breakpoints)

const schoolStore = useSchoolStore()
const { directions, lessonTypes, gallery, trainers } = storeToRefs(schoolStore)

const directoryStore = useDirectoryStore()
const { news } = storeToRefs(directoryStore)

const { untilReady } = await useRegionReady()

const { pending } = await useAppAsyncData(
  `school-about-${route.params.id}`,
  async () => {
    await untilReady()
    await Promise.all([
      directoryStore.fetchTrainers(),
      directoryStore.fetchNews(),
    ])
  },
)

const galleryImagesAmount = computed(() => {
  if (import.meta.client) {
    if (isMobile.value) {
      return 1.2
    }

    if (isLessThan('lg')) {
      return 2.2
    }
  }

  return 3
})
</script>

<style lang="scss" scoped></style>
